// import './app.scss';
import { LayoutSplashScreen } from './components/layout/splash-screen/splash-screen.context';
import { MasterInit } from './layouts/master-init';
import { AuthInit } from 'features/auth/contexts/auth';
import 'flatpickr/dist/flatpickr.min.css';
import 'flatpickr/dist/plugins/monthSelect/style.css';
//import 'flatpickr/dist/themes/material_blue.css';
import { I18nProvider } from 'i18n/contexts/intl';
import { LayoutProvider } from 'layouts/core/layout.context';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';

function MainApp() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <LayoutProvider>
          <AuthInit>
            <Outlet />
            <MasterInit />
          </AuthInit>
        </LayoutProvider>
      </I18nProvider>
    </Suspense>
  );
}

export default MainApp;
